import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: ${({ theme }) => theme.background.color};
  min-height: 100vh;
  position: relative;
`;
